import { WSList, WSText } from "@wingspanhq/fe-component-library";
import {
  GetMissingFieldsLevelParameter,
  VerificationLevel
} from "@wingspanhq/wingspan-api-sdk";
import { useMemo } from "react";
import { queriesOnboarding } from "@query";
import { verificationService } from "../../../../shared/services/verificaiton";
import { CardTaxVerificationRequirementRequester } from "../../components/CardTaxVerificationRequirementRequester";
import { useOnboardignModules, useOnboardingContext } from "../../Context";
import { OnboardingModuleCreateAccount } from "../../types";
import { CreateAccountContext } from "./types";
import { useRedirectToAccountType } from "./useRedirectToAccountType";
import { FormUSInternationalPersonInformation } from "../../components/FormUSInternationalPersonInformation";
import { FlowStep } from "../../../../shared/components/FlowSwitch/types";

export const InternationalUSPersonInformation: React.FC<FlowStep> = ({
  onNext,
  onBack
}) => {
  const [context, setContext] = useOnboardingContext<CreateAccountContext>();

  const queryOnboardingStatus = queriesOnboarding.getOnboardingStatus.useQuery(
    {}
  );

  const modules = useOnboardignModules();
  const onboardingModule = modules.find(m => m.type === "create_account") as
    | OnboardingModuleCreateAccount
    | undefined;
  const verificationLevel =
    onboardingModule?.options?.verificationLevel || "Tax";

  const queryMissingData = queriesOnboarding.getMissingFields.useQuery({
    level: verificationLevel as GetMissingFieldsLevelParameter
  });

  const isUsPersonMismatch = useMemo(
    () =>
      verificationService.getIsUsPersonMismatch(
        queryMissingData.data?.profiles?.["US"]?.requiredFields || []
      ),
    [queryMissingData.data?.profiles]
  );

  const isUSPersonFormCompleted = useMemo(
    () =>
      queryOnboardingStatus.data?.verifications?.profiles?.["US"]?.tax ===
      VerificationLevel.VERIFIED,
    [queryOnboardingStatus.data]
  );

  useRedirectToAccountType();

  return (
    <WSList gap="2XL">
      <CardTaxVerificationRequirementRequester />

      <FormUSInternationalPersonInformation
        defaultValues={context.usInternationalPersonInformation}
        onBack={onBack}
        onSubmit={data => {
          isUSPersonFormCompleted ||
            setContext(prev => ({
              ...prev,
              usInternationalPersonInformation: data
            }));
          onNext?.();
        }}
        mismatch={isUsPersonMismatch}
        completed={isUSPersonFormCompleted}
      />

      <WSText.ParagraphXs color="gray400">
        The information on this page is required to setup your Wingspan account,
        if you exit or leave without completing this step, you will return to
        this page the next time you sign-in
      </WSText.ParagraphXs>
    </WSList>
  );
};
